/**
 * This Software is the property of dotfly and is protected
 * by copyright law - it is NOT Freeware.
 *
 * Any unauthorized use of this software without a valid license key
 * is a violation of the license agreement and will be prosecuted by
 * civil and criminal law.
 *
 * @category   Modal trigger
 * @author     Lennart Syré <lennart.syre@dotfly.de>
 * @license    http://www.dotfly.de Commercial
 * @link       http://www.dotfly.de
 */

let triggerGroup = document.querySelectorAll('.js-trigger-modal, .js-modal-close');

const toggleModal = (element) => {
    if (!element.classList.contains('active')) {
        element.classList.add('active');
    } else {
        element.classList.remove('active');
    }
};

if (triggerGroup) {

    //loop over all existing triggers
    triggerGroup.forEach(trigger => {

        //add click to each trigger
        trigger.addEventListener('click', () => {
            let modal;

            //get modal related to the trigger
            if (trigger.classList.contains('js-trigger-modal')) {
                modal = trigger.parentElement.nextElementSibling;
            } else if (trigger.classList.contains('close')) {
                modal = trigger.parentElement.parentElement.parentElement;
            } else {
                modal = trigger.parentElement.parentElement.parentElement.parentElement.parentElement;
            }
            toggleModal(modal);
        });
    });
}
